/* ============================================================
 * Códigos promocionales. Solo Aleph.
 *
 * Un código vale en toda la red y descuenta sobre el precio de la sesión
 * de cada centro: un porcentaje, o un monto fijo en pesos. El descuento se
 * congela en cada reserva, así que pausar un código no toca lo ya
 * reservado — por eso aquí no hay borrar, solo pausar.
 * ============================================================ */

import React, { useState } from 'react';
import { useRecurso, useAccion, api } from '../estado.jsx';
import { Recurso } from './Comunes.jsx';

const clp = (n) => '$' + (n || 0).toLocaleString('es-CL');

export function CodigosView() {
  const codigos = useRecurso(() => api.codigos(), []);
  const { ejecutar, enCurso, error, setError } = useAccion();

  const [codigo, setCodigo] = useState('');
  const [tipo, setTipo] = useState('porcentaje');
  const [valor, setValor] = useState('');
  const [hasta, setHasta] = useState('');
  const [maxUsos, setMaxUsos] = useState('');

  const crear = () => {
    const c = codigo.trim().toUpperCase();
    const v = parseInt(valor, 10);
    if (!/^[A-Z0-9ÑÁÉÍÓÚ-]{3,30}$/.test(c)) {
      setError('El código: de 3 a 30 letras o números, sin espacios.');
      return;
    }
    if (!Number.isInteger(v) || v <= 0) { setError('Indica el valor del descuento.'); return; }
    if (tipo === 'porcentaje' && v > 100) { setError('Un porcentaje no puede superar 100.'); return; }
    ejecutar(
      () => api.crearCodigo({
        codigo: c, tipo, valor: v,
        hasta: hasta || undefined,
        maxUsos: maxUsos ? parseInt(maxUsos, 10) : undefined,
      }),
      () => { setCodigo(''); setValor(''); setHasta(''); setMaxUsos(''); },
    );
  };

  const descuento = (c) => (c.tipo === 'porcentaje' ? `−${c.valor}%` : `−${clp(c.valor)}`);
  const vigencia = (c) => {
    if (!c.hasta) return 'Sin caducidad';
    const f = String(c.hasta).slice(0, 10);
    return `Hasta el ${f.slice(8, 10)}/${f.slice(5, 7)}/${f.slice(0, 4)}`;
  };

  return (
    <div className="view on">
      <div className="h-eyebrow">Aleph · Administración</div>
      <h1 className="h-title">Códigos <em>promocionales</em></h1>
      <p className="h-sub">
        Valen en toda la red y descuentan sobre el precio de la sesión de cada
        centro. El cliente lo escribe al reservar y ve su precio final al momento.
      </p>

      <h2 className="section-h">Crear un código</h2>
      <div className="oferta-form bono-form">
        <div className="field" style={{ margin: 0 }}><label>Código</label>
          <input className="inp" value={codigo}
                 onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                 placeholder="VERANO25" /></div>

        <div className="field" style={{ margin: 0 }}><label>Descuento</label>
          <select className="inp" value={tipo} onChange={(e) => setTipo(e.target.value)}>
            <option value="porcentaje">Porcentaje (%)</option>
            <option value="monto">Monto fijo ($)</option>
          </select></div>

        <div className="field" style={{ margin: 0 }}>
          <label>{tipo === 'porcentaje' ? '% de descuento' : 'Pesos de descuento'}</label>
          <input className="inp" type="number" min="1" value={valor}
                 onChange={(e) => setValor(e.target.value)}
                 placeholder={tipo === 'porcentaje' ? '10' : '5000'} /></div>

        <div className="field" style={{ margin: 0 }}><label>Caduca (opcional)</label>
          <input className="inp" type="date" value={hasta}
                 onChange={(e) => setHasta(e.target.value)} /></div>

        <div className="field" style={{ margin: 0 }}><label>Usos máx. (opcional)</label>
          <input className="inp" type="number" min="1" value={maxUsos}
                 onChange={(e) => setMaxUsos(e.target.value)}
                 placeholder="Sin límite" /></div>

        <button className="btn" onClick={crear} disabled={enCurso}>
          {enCurso ? 'Creando…' : 'Crear código'}
        </button>
      </div>

      <div className="inline-err show">{error}</div>

      <h2 className="section-h">Códigos de la red</h2>
      <Recurso estado={codigos} que="los códigos">
        {(lista) => lista.length === 0 ? (
          <p className="section-note">Aún no hay códigos. El primero que crees aparecerá aquí.</p>
        ) : (
          <div className="card"><table className="stable">
            <thead><tr><th>Código</th><th>Descuento</th><th>Vigencia</th>
                       <th className="num">Usos</th><th>Estado</th><th /></tr></thead>
            <tbody>{lista.map((c) => (
              <tr key={c.id} style={c.activo ? undefined : { opacity: 0.5 }}>
                <td><b>{c.codigo}</b></td>
                <td>{descuento(c)}</td>
                <td>{vigencia(c)}</td>
                <td className="num">{c.usos}{c.max_usos ? ` / ${c.max_usos}` : ''}</td>
                <td>{c.activo
                  ? <span className="pill">Activo</span>
                  : <span style={{ color: 'var(--err)' }}>Pausado</span>}</td>
                <td className="num">
                  <button className="tlink" disabled={enCurso}
                          onClick={() => ejecutar(() => api.cambiarCodigo(c.id, !c.activo))}>
                    {c.activo ? 'Pausar' : 'Reactivar'}
                  </button>
                </td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </Recurso>

      <p className="section-note" style={{ marginTop: 18 }}>
        Pausar un código no toca las reservas que ya lo usaron: su descuento
        quedó congelado al reservar.
      </p>
    </div>
  );
}
